// extracted by mini-css-extract-plugin
export default {"table_wrap":"travelDetails_table_wrap__FKUMM"};